const narrowQuery = window.matchMedia('(max-width: 767px)');
const wideQuery = window.matchMedia('(min-width: 768px)');

const ASSETS_PATH_MAP = {
  ja: '/jp/ja/sf2030',
  en: '/global/en/sf2030',
  cn: '/global/cn/sf2030'
};

export { narrowQuery, wideQuery, ASSETS_PATH_MAP };
